import { createSelector } from "@ngrx/store";
import { PERMISSION } from "../../../app.costants";
import { storeSelector } from "../../../store/store.selector";

export const selectUserPermissions = createSelector(
  storeSelector,
  store => {
    const internalRole = store?.user?.ruolo;
    const situazioneRuoli = store?.situazioneRuoli;

    if (internalRole && situazioneRuoli) {
      const ruolo = situazioneRuoli?.ruoli?.find(ruolo => ruolo.id_ruolo === internalRole);
      if (!ruolo) {
        console.log("DA FIXARE - non trovo il ruolo")
        return []
      }
      return (situazioneRuoli?.permessi || [])
        .filter(permesso => ruolo.permessi.includes(permesso.id_permesso))
        .map(permesso => permesso.permesso.toLowerCase());
    } else {
      return [];
    }
  }
);

export const canNotifyPasswordChange = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.NOTIFY_PASSWORD_CHANGE) > -1,
);

export const canAdminInactiveUserCancellationChange = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.INACTIVE_USER_CANCELLATION) > -1,
);

export const canViewEvents = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.VIEW_LOGS) > -1,
);

export const canAdminUserCancellation = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.USER_CANCELLATION) > -1,
);

export const canAdminUserAddition = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.USER_ADDITION) > -1,
);

export const enableSearchIrenYou = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.SEARCH_IRENYOU) > -1,
);

export const enableUserDuplicated = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.USER_DUPLICATED) > -1,
);

export const enableReviews = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.REVIEWS) > -1,
);

export const enableExactAssociation = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.EXACT_ASSOCIATION) > -1,
);

export const userExtraction = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.USER_EXTRACTION) > -1,
);

export const enableSearchAssociation = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.SEARCH_ASSOCIATION) > -1,
);

export const enablePrivacyTc = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.PRIVACY_TC) > -1,
);

export const enableAgingFatture = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.AGING_FATTURE) > -1,
);

export const enableRicercaUtentiFb = createSelector(
  selectUserPermissions,
  (permessi) => permessi.indexOf(PERMISSION.RICERCA_UTENTI_FB) > -1,
);
